<template>
    <div class="ui-page">
        <ui-page-header :title="page.title" back="/comarcas" back-text="Comarcas">
            <v-btn v-if="(page.isNew) && $allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.addLoading" @click="add">Salvar</v-btn>
            <v-btn v-else-if="$allowed('save')" id="btnSave" color="primary" depressed :loading="dataForm.updateLoading" @click="update">Salvar</v-btn>
        </ui-page-header>

        <v-form :readonly="!$allowed('save')" ref="form" v-model="dataForm.validForm">
            <ui-section title="Detalhes">
                <v-text-field dense label="Nome" v-model="dataset.data.name" required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
            </ui-section>
        </v-form>
    </div>
</template>

<script>

import axios from "axios"

export default {
    name: "DistrictDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        menu: false,
        dataset: {
            breadcrumbItems: [],
            date: null,
            data: {},
            clients: []
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
        },
    }),

    created() {
        this.loadData()
    },

    computed: {
        computedDateFormatted() {
            return this.formatDate(this.dataset.data.date)
        },
    },


    methods: {
        goBack() {
            this.$router.replace("/comarcas");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Nova comarca" : "Detalhes da Comarca";
        },

        formatDate(date) {
            if (!date) return null

            return this.$moment(date).format('DD/MM/YYYY')
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Comarcas",
                disabled: false,
                to: "/comarcas",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes da Comarca`,
                disabled: true,
                exact: true,
            });
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a Comarca?',
                title: 'Incluir Comarca',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/admin/districts', payload);

                this.$dialog.notify.info("Comarca salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a Comarca?',
                title: 'Atualizar Comarca',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                await axios.patch(`/api/admin/districts/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Comarca salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/admin/districts/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
            }

            return data;
        },


    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
